import {
    ActionIcon,
    Badge,
    Box,
    Button,
    Checkbox,
    Flex,
    Group,
    Stack,
    Text,
} from '@mantine/core';

import CreateDatasetModal from '../../modals/CreateDatasetModal';
import FiltersMultiSelect from '../../../../common/filtersMultiSelect/FiltersMultiSelect';
import { IconPlus } from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';

const DatasetsTableToolbar = ({
    filterOptions,
    rightSection,
    actionButtons: ToolbarActions,
    showHidden,
    toggleShowHidden,
}) => {
    const [
        createModalOpen,
        { open: openCreateModal, close: closeCreateModal },
    ] = useDisclosure();
    return (
        <>
            <Group
                ms={'xs'}
                gap={'xs'}
                align='flex-start'
                w={'100%'}>
                <FiltersMultiSelect options={filterOptions} />
            </Group>
            <Flex
                px={'md'}
                w={'100%'}
                align={'bottom'}
                justify={'flex-end'}>
                <Button
                    onClick={openCreateModal}
                    size={'compact-xs'}
                    leftSection={
                        <IconPlus
                            style={{ width: '70%', height: '70%' }}
                            stroke={1.5}
                        />
                    }
                    styles={{
                        section: {
                            marginInlineEnd: 0,
                        },
                    }}>
                    New Dataset
                </Button>
            </Flex>
            {rightSection}
            <CreateDatasetModal
                opened={createModalOpen}
                close={closeCreateModal}
            />
        </>
    );
};
export default DatasetsTableToolbar;
